// components
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AddCircleIcon from '@mui/icons-material/AddCircle';
import TableViewIcon from "@mui/icons-material/TableView";
import ChecklistTypeQuestionCreateInner from "./ChecklistTypeQuestionCreateInner";


class ChecklistTypeQuestionCreate extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: AddCircleIcon,
            buttonLabel: 'Добавить',
            buttonColor: 'primary',
            ready: true,
        })
    }

    async beforeModalOpen(){
        return {
            modalLabel: 'Добавление типа',
            modalIcon: TableViewIcon,
            mainComponent: ChecklistTypeQuestionCreateInner,
            mainComponentProps: {
                checklistType: this.props.checklistType,
                callBack: this.processCallBack.bind(this),
            },
        }
    }

    async processCallBack(){
        await this.props.callBack();
        this.setModalOpenFalse()
    }
}

export default ChecklistTypeQuestionCreate
